<template>
   <div class="themeCont">
     <div class="header">
       <span class="h_back" @click="back"></span>
       <span class="h_title">{{name}}</span>
     </div>
    <!-- <div class="title">
       <span class="ellipse">{{name}}</span>
       <span>共 {{list.length}} 张</span>
     </div>-->
     <ul class="ullist">
       <li v-for="item in list" @click="gotdetail(item.collectionId)">
         <span>{{item.collectionName}}</span>
         <img :src="item.pictureUrl" alt="" :onerror="defaultImg">
       </li>
     </ul>
   </div>
</template>

<script>
  import {api} from '../global/api';
    export default {
        name: "themeList",
      data(){
        return{
          list:[],
          defaultImg: this.$store.getters.defaultImg,
          id:"",
          name:""
        }
      },
    mounted(){
          var that=this;
      this.id=this.$route.query.id;
      this.$http.get(api.themelist+"?id="+this.id).then((res)=>{
        that.list=res.data.data.pictureList;
        that.name=res.data.data.tourName;

      })
    },
      methods:{
        gotdetail(num){
          this.$router.push({path:'/ThemeDetail',query:{"collectionId":num,"tourId":this.id}});
        },
        back(){
          this.$router.go(-1);
        }
      }
    }
</script>

<style scoped>
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 9rem;
    margin: 0 auto;
  }
  .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .themeCont{
    background-color: #F1F1F1;
  }
.title{
  height: 3rem;
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background-color: white;
}
  .title span:nth-child(1){
    width: 12rem;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    height:1.05rem;
    font-size:0.75rem;
    font-family:PingFang-SC-Bold;
    font-weight:bold;
    color:rgba(102,102,102,1);
    line-height:1rem;
  }
.title span:nth-child(2){
  width:4rem;
  height:1rem;
  font-size:0.65rem;
  font-family:PingFang-SC-Regular;
  font-weight:400;
  color:rgba(185,185,185,1);
  line-height:1rem;
  text-align: right;
}
.ullist{
  margin-top: 2.75rem;
  padding: 1rem 1.25rem;
  background-color: white;
}
  .ullist:after{
    content:".";
    display:block;
    height:0;
    clear:left;
    visibility:hidden;
  }
  .ullist li{
    float: left;
    width: 7.5rem;
    margin-right: 1.25rem;
    margin-bottom: 1rem;
  }
  .ullist li:nth-of-type(2n){
    margin-right: 0;
  }
  .ullist li span{
    height:1.05rem;
    font-size:0.75rem;
    font-family:PingFang-SC-Bold;
    font-weight:bold;
    color:rgba(102,102,102,1);
    line-height:1.05rem;
    overflow:hidden;
    text-overflow:ellipsis;
    margin-bottom: .5rem;
    display: block;
    white-space:nowrap;
  }
  .ullist li img{
    width: 7.5rem;
    height: 7.5rem;
    border-radius:0.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/themeList.vue